import React from 'react';
import { Goal } from '../../types/goals';
import ShareOptionsMenu, { ShareOption } from './ShareOptionsMenu';
import logger from '../../utils/logger';

export interface ShareGoalButtonProps {
  goal: Goal;
  className?: string;
  buttonLabel?: string;
  buttonVariant?: 'primary' | 'secondary' | 'outlined' | 'text';
  buttonSize?: 'sm' | 'md' | 'lg';
}

const ShareGoalButton: React.FC<ShareGoalButtonProps> = ({
  goal,
  className,
  buttonLabel = 'Share Goal',
  buttonVariant = 'outlined',
  buttonSize = 'md',
}) => {
  const shareViaFacebook = () => {
    const url = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(window.location.href)}`;
    window.open(url, '_blank', 'width=600,height=400');
  };

  const shareViaTwitter = () => {
    const text = `Check out my goal: ${goal.name} on Marune!`;
    const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(window.location.href)}`;
    window.open(url, '_blank', 'width=600,height=400');
  };

  const shareViaWhatsApp = () => {
    const text = `Check out my goal: ${goal.name} on Marune! ${window.location.href}`;
    const url = `https://wa.me/?text=${encodeURIComponent(text)}`;
    window.open(url, '_blank');
  };

  const copyLink = () => {
    navigator.clipboard.writeText(window.location.href)
      .then(() => {
        // You could show a toast notification here
        logger.info('Link copied to clipboard');
      })
      .catch(err => {
        logger.error('Failed to copy link:', err);
      });
  };

  const shareOptions: ShareOption[] = [
    {
      id: 'facebook',
      label: 'Share on Facebook',
      icon: 'facebook',
      action: shareViaFacebook
    },
    {
      id: 'twitter',
      label: 'Share on Twitter',
      icon: 'twitter',
      action: shareViaTwitter
    },
    {
      id: 'whatsapp',
      label: 'Share on WhatsApp',
      icon: 'whatsapp',
      action: shareViaWhatsApp
    },
    {
      id: 'copy',
      label: 'Copy Link',
      icon: 'link',
      action: copyLink
    }
  ];

  return (
    <ShareOptionsMenu
      options={shareOptions}
      className={className}
      buttonLabel={buttonLabel}
      buttonVariant={buttonVariant}
      buttonSize={buttonSize}
      buttonIcon="share"
      title={`Share Goal: ${goal.name}`}
    />
  );
};

export default ShareGoalButton;